module.exports = __webpack_public_path__ + "Icoreq_med.png";